import styled from "styled-components";

export const Column = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  width: 100%;
  max-width: 34.75rem;

  position: sticky;
  top: 2.5rem;

  @media (max-width: 750px) {
    position: static;
  }
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 1.5rem;

  border-radius: 1rem;
  background: ${({ theme }) => theme.checkoutStepsOffers?.cardBackground};

  @media (max-width: 750px) {
    display: none;
  }
`;

export const SectionTitle = styled.h1`
  padding: 0 0 1rem;
  margin: 0 0 1rem;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.688rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};
  border-bottom: 0.063rem solid
    ${({ theme }) => theme.checkoutStepsOffers?.widgetBackground};
`;
